import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';

import {
  getPricingListByTypeandCat,
  GetPricingListByTypeandCatParams,
  PricingResponse,
} from 'services/pricing';

export type PricingListSelectProps = {
  params: GetPricingListByTypeandCatParams;
  value?: any;
  onChange?: (pricing?: PricingResponse | any) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  defaultValue?: any;
  onlyOfrid?: boolean;
  onlyServ?: boolean;
};

const PricingListSelect = ({
  params,
  value,
  onChange = noop,
  allowClear,
  defaultValue,
  onlyOfrid,
  onlyServ,
  ...otherProps
}: PricingListSelectProps) => {
  const { data: pricings, isLoading } = useQuery(
    ['getPricingListByTypeandCat', params],
    () =>
      getPricingListByTypeandCat(params).then((res) =>
        onlyServ
          ? res.list.filter((e: any) => e.ctetype === 'SERV')
          : res.list || []
      )
  );

  const handleChange: SelectProps<number>['onChange'] = (value) => {
    onlyOfrid
      ? onChange(value)
      : onChange(pricings?.find((pricing) => pricing.priid === value));
  };

  return (
    <Select
      value={value?.priid ?? value}
      onChange={handleChange}
      {...otherProps}
      loading={isLoading}
      defaultValue={defaultValue?.priid ?? defaultValue}
      allowClear={allowClear}
    >
      {pricings?.map((pricing) => (
        <Select.Option value={pricing.priid} key={pricing.priid}>
          {pricing.prilabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default PricingListSelect;
